/**
 * DevExtreme (ui/tree_list/ui.tree_list.js)
 * Version: 17.2.7
 * Build date: Fri Mar 16 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
var TreeList = require("./ui.tree_list.base");
module.exports = TreeList;
require("./ui.tree_list.column_chooser");
require("./ui.tree_list.master_detail");
require("./ui.tree_list.editing");
require("./ui.tree_list.validating");
require("./ui.tree_list.virtual_scrolling");
require("./ui.tree_list.filter_row");
require("./ui.tree_list.header_filter");
require("./ui.tree_list.columns_resizing_reordering");
require("./ui.tree_list.column_fixing");
require("./ui.tree_list.adaptivity");
require("./ui.tree_list.selection");
require("./ui.tree_list.search");
require("./ui.tree_list.keyboard_navigation");



//////////////////
// WEBPACK FOOTER
// ./node_modules/devextreme/ui/tree_list/ui.tree_list.js
// module id = ./node_modules/devextreme/ui/tree_list/ui.tree_list.js
// module chunks = vendor